import {
    TextField,
    Button,
    IconButton,
    CircularProgress,
    Dialog,
    Tooltip
} from "@mui/material"
import {
    Search,
    PersonSearch,
    CheckCircle,
    Error,
    Close,
    WatchLater,
    KeyboardBackspace
} from "@mui/icons-material"
import LoadingSpinner from "../../../animation/LoadingSpinner"
import { H5, Body2, H4, Body3, H3 } from "../../../themes/typography"

export default function ManualSearch({
    onManualTicketSearch = () => { },
    searchTerm,
    loading = false,
    manualSearchResult,
    openModal,
    onDismiss = () => { },
    onSearchInputChange = () => { },
    onCheckIn = () => { },
    onReject = () => { },
    detailsLoading,
    processType,
    onBack = () => { },
    onViewTicket = () => { },
    isViewDetailActive,
    viewDetailsData,
    isCountDownActive
}) {

    // console.log("isCountDownActive in Manual Search -> ", isCountDownActive);

    return (

        <div className="manual-attendance-search">

            <div className="manual-search-title-container">
                <PersonSearch color="white" />
                <H5>
                    Manual Ticket Search
                </H5>
            </div>

            <div className="manual-search-input-container">

                {isCountDownActive === 'on' && (
                    <Tooltip title="Manual search will be start when the event is live.">
                        <TextField
                            fullWidth
                            label="Search by ticket id"
                            value={searchTerm}
                            onChange={onSearchInputChange}
                            sx={{
                                '& .MuiOutlinedInput-input': {
                                    padding: '14px 14px 14px 14px',
                                }
                            }}
                            // autoFocus
                            placeholder="Enter ticket ID (e.g. TIX35934494)"
                            // disabled={isCountDownActive === 'on'}
                        />
                    </Tooltip>
                )}

                {isCountDownActive === 'off' && (
                    <TextField
                        fullWidth
                        label="Search by ticket id"
                        value={searchTerm}
                        onChange={onSearchInputChange}
                        sx={{
                            '& .MuiOutlinedInput-input': {
                                padding: '14px 14px 14px 14px',
                            }
                        }}
                        autoFocus
                        placeholder="Enter ticket ID (e.g. TIX35934494)"
                    />
                )}

                {isCountDownActive === 'windowEnded' && (
                    <Tooltip title="Manual search is disabled when the event has ended.">
                        <TextField
                            fullWidth
                            label="Search by ticket id"
                            value={searchTerm}
                            onChange={onSearchInputChange}
                            sx={{
                                '& .MuiOutlinedInput-input': {
                                    padding: '14px 14px 14px 14px',
                                }
                            }}
                            autoFocus
                            placeholder="Enter ticket ID (e.g. TIX35934494)"
                            disabled={isCountDownActive === 'windowEnded'}
                        />
                    </Tooltip>
                )}

                <IconButton
                    sx={{
                        background: 'var(--secondary-color)',
                        borderRadius: '0.75rem',
                        padding: '12px',
                        '&:hover': {
                            background: 'var(--secondary-color)'
                        },
                        '&.Mui-disabled': {
                            background: 'var(--secondary-color)',
                            color: 'var(--quaternary-color)',
                            opacity: '0.7'
                        }
                    }}
                    disabled={!searchTerm || searchTerm.trim() === ''}
                    onClick={onManualTicketSearch}
                >
                    <Search sx={{ fontSize: '1.6rem' }} />
                </IconButton>
            </div>


            {loading && <LoadingSpinner message="Searching your ticket..." />}


            <div className="manual-search-result-container">

                {manualSearchResult && !loading && (
                    <div className="manual-search-result-content">
                        <Dialog
                            open={true}
                            sx={{
                                '& .MuiPaper-root': {
                                    background: 'transparent',
                                    borderRadius: '0',
                                    boxShadow: 'none',
                                }
                            }}
                        >
                            {openModal === 'validTicket' && (
                                <ValidTicket
                                    data={manualSearchResult}
                                    onCheckIn={onCheckIn}
                                    onReject={onReject}
                                    onDismiss={onDismiss}
                                    detailsLoading={detailsLoading}
                                    processLoaderType={processType}
                                />
                            )}

                            {openModal === 'alreadyScannedTicket' && (

                                <AlreadyScannedTicket
                                    data={manualSearchResult}
                                    onCheckIn={onCheckIn}
                                    onViewTicketDetails={onViewTicket}
                                    onReject={onReject}
                                    onDismiss={onDismiss}
                                    detailsLoading={detailsLoading}
                                    processLoaderType={processType}
                                    isViewDetailActive={isViewDetailActive}
                                    onBack={onBack}
                                    viewDetailsData={viewDetailsData}
                                />
                            )}

                            {openModal === 'tooEarly' && (
                                <TooEarlyTicket
                                    data={manualSearchResult}
                                    onCheckIn={onCheckIn}
                                    onDismiss={onDismiss}
                                />
                            )}

                            {openModal === 'event/slotEnded' && (
                                <EventEndedTicket
                                    data={manualSearchResult}
                                    onCheckIn={onCheckIn}
                                    onDismiss={onDismiss}
                                />
                            )}

                            {openModal === 'enoughPermission' && (
                                <EnoughPermissionTicket
                                    data={manualSearchResult}
                                    onCheckIn={onCheckIn}
                                    onDismiss={onDismiss}
                                />
                            )}

                            {openModal === 'wrongEventTicket' && (
                                <WrongEventTicket onDismiss={onDismiss} />
                            )}

                            {openModal === 'invalidTicketNumber' && (
                                <InvalidQRCode onDismiss={onDismiss} />
                            )}
                        </Dialog>
                    </div>
                )}
            </div>

        </div>
    )
}

function ValidTicket({
    onCheckIn = () => { },
    onReject = () => { },
    onDismiss = () => { },
    data = null,
    detailsLoading,
    processLoaderType,
}) {
    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper valid-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onDismiss} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <CheckCircle color="success" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    Ticket is valid and ready for check-in. You can proceed to check in the guest.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_id}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_type}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled={(detailsLoading && processLoaderType === 'checkIn')}
                            onClick={onCheckIn}
                        >
                            Check In Guest {detailsLoading && processLoaderType === 'checkIn' && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--primary-color)'
                                    }}
                                />
                            )}
                        </Button>

                        <Button
                            variant="reject"
                            disabled={(detailsLoading && processLoaderType === 'reject')}
                            onClick={onReject}
                        >
                            Reject {detailsLoading && processLoaderType === 'reject' && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--error-main-color)'
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    )
}

function AlreadyScannedTicket({
    onCheckIn = () => { },
    onDismiss = () => { },
    onViewTicketDetails = () => { },
    onBack = () => { },
    onReject = () => { },
    isViewDetailActive = false,
    data = null,
    viewDetailsData,
    detailsLoading,
    processLoaderType
}) {

    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div
                    className="overlay-close-container"
                    style={{ justifyContent: isViewDetailActive ? 'space-between' : 'flex-end' }}
                >
                    {isViewDetailActive && (
                        <IconButton onClick={onBack} sx={{ padding: '0' }}>
                            <KeyboardBackspace />
                        </IconButton>
                    )}

                    {isViewDetailActive && (
                        <H5>
                            Scan History
                        </H5>
                    )}

                    <IconButton onClick={onDismiss} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    {!isViewDetailActive && (
                        <div className="main-ticket-status-details">
                            <div className="ticket-status-container">
                                <div className="ticket-status-icon">
                                    <Error color="secondary" sx={{ fontSize: '3rem' }} />
                                </div>

                                <div className="ticket-status-title">
                                    <H3 fontWeight={700}>
                                        Valid Ticket
                                    </H3>
                                </div>

                            </div>

                            <div className="ticket-subtitle-and-details">
                                <div className="ticket-status-subtitle">
                                    <Body2>
                                        Ticket has been checked in multiple times. Please review ticket details.
                                    </Body2>
                                </div>

                                <div className="ticket-status-details">

                                    <div className="each-ticket-detail">
                                        <div className="each-ticket-detail-label">
                                            <Body2>
                                                Ticket ID:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2>
                                                {data?.ticket?.ticket_id}
                                            </Body2>
                                        </div>
                                    </div>

                                    <div className="each-ticket-detail">
                                        <div className="each-ticket-detail-label">
                                            <Body2>
                                                Ticket Type:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2>
                                                {data?.ticket?.ticket_type}
                                            </Body2>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    )}

                    {isViewDetailActive && (
                        <div className="main-ticket-status-details">

                            <div className="scan-history-ticket-details-container">

                                <div className="ticket-holder-details">
                                    <div className="align-flex-start each-ticket-detail">
                                        <div className="width-label each-ticket-detail-label">
                                            <Body2 fontWeight={400}>
                                                Holder Name:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2 fontWeight={350}>
                                                {data?.ticket?.attendee_name}
                                            </Body2>
                                        </div>
                                    </div>
                                    <div className="align-flex-start each-ticket-detail">
                                        <div className="width-label each-ticket-detail-label">
                                            <Body2 fontWeight={400}>
                                                Ticket Name:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2 fontWeight={350}>
                                                {data?.ticket?.ticket_type}
                                            </Body2>
                                        </div>
                                    </div>
                                </div>

                                <div className="ticket-scanning-history">

                                    <div className="scan-history-list">
                                        {viewDetailsData && viewDetailsData?.attendances?.length === 0 && (
                                            <Body2>No scan history available for this ticket.</Body2>
                                        )}

                                        {viewDetailsData &&
                                            viewDetailsData?.attendances?.length > 0 &&
                                            viewDetailsData?.attendances?.map((attendance, index) => (
                                                <div className="scan-history-item" key={index}>
                                                    <div className="scan-history-info">
                                                        <div className="scan-history-person">
                                                            <Body3 fontWeight={500}>
                                                                {attendance.checked_in_by}
                                                            </Body3>
                                                        </div>
                                                        <div className="scan-history-datetime">
                                                            <Body3>
                                                                {attendance.action_time}
                                                            </Body3>
                                                        </div>
                                                    </div>
                                                    <div className="scan-history-status">
                                                        {attendance.action === 'checked_in' && (
                                                            <Body3 fontWeight={500} color="var(--success-main-color)">
                                                                Checked In
                                                            </Body3>
                                                        )}

                                                        {attendance.action === 'rejected' && (
                                                            <Body3 fontWeight={500} color="var(--error-main-color)">
                                                                Rejected
                                                            </Body3>
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    )}

                    <div className="ticket-status-actions">
                        {isViewDetailActive && (
                            <Button
                                variant="main"
                                fullWidth
                                disabled={(detailsLoading && processLoaderType === 'checkIn')}
                                onClick={onCheckIn}
                            >
                                Check In Guest {detailsLoading && processLoaderType === 'checkIn' && (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            marginLeft: '0.75rem',
                                            color: 'var(--primary-color)'
                                        }}
                                    />
                                )}
                            </Button>
                        )}

                        {!isViewDetailActive && (
                            <Button
                                variant="main"
                                fullWidth
                                disabled={detailsLoading && processLoaderType === 'viewDetails'}
                                onClick={onViewTicketDetails}
                            >
                                View Details {detailsLoading && processLoaderType === 'viewDetails' && (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            marginLeft: '0.75rem',
                                            color: 'var(--primary-color)'
                                        }}
                                    />
                                )}
                            </Button>
                        )}

                        <Button
                            variant="reject"
                            disabled={(detailsLoading && processLoaderType === 'reject')}
                            onClick={onReject}
                        >
                            Reject {detailsLoading && processLoaderType === 'reject' && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--error-main-color)'
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function TooEarlyTicket({
    onCheckIn = () => { },
    onDismiss = () => { },
    data = null,
}) {
    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onDismiss} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <WatchLater color="secondary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    The event has not started yet. Please wait until event start to check-in.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_id}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_type}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                            onClick={onCheckIn}
                        >
                            Check In Guest
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onDismiss}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function EventEndedTicket({
    onCheckIn = () => { },
    onDismiss = () => { },
    data = null,
}) {
    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onDismiss} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <WatchLater color="secondary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    The event or selected time slot has ended. Check-in is no longer allowed.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_id}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_type}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                            onClick={onCheckIn}
                        >
                            Check In Guest
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onDismiss}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function EnoughPermissionTicket({
    onCheckIn = () => { },
    onDismiss = () => { },
    data = null,
}) {
    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onDismiss} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <WatchLater color="secondary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    The ticket holder has sufficient permissions for the event. Check-in is not required.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_id}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {data?.ticket?.ticket_type}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                            onClick={onCheckIn}
                        >
                            Check In Guest
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onDismiss}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function WrongEventTicket({
    onDismiss = () => { }
}) {
    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper invalid-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onDismiss}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="ticket-status-container">
                        <div className="ticket-status-icon">
                            <Error color="error" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="ticket-status-title">
                            <H4 fontWeight={700}>
                                Invalid Ticket
                            </H4>
                        </div>

                        <div className="ticket-status-subtitle">
                            <Body2>
                                The ticket is not valid for this event. Do not allow to check-in.
                            </Body2>
                        </div>

                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onDismiss}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function InvalidQRCode({
    onDismiss = () => { }
}) {
    return (
        <div className="ticket-status-overlay position-static">
            <div
                className={`ticket-status-overlay-wrapper invalid-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onDismiss}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="ticket-status-container">
                        <div className="ticket-status-icon">
                            <Error color="error" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="ticket-status-title">
                            <H4 fontWeight={700}>
                                Invalid Ticket
                            </H4>
                        </div>

                        <div className="ticket-status-subtitle">
                            <Body2>
                                The ticket number is invalid. Please check the ticket number and try again.
                            </Body2>
                        </div>

                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onDismiss}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}